import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ImageMapBanner from 'yoda-core-components/lib/components/ImagemapBannerResponsive/ImagemapBannerResponsive';
import { replaceSubdomain } from 'yoda-core-components/lib/helpers/Utils/Utils';

class IrisImageMapBanner extends PureComponent {
    static propTypes = {
        channels: PropTypes.oneOfType([PropTypes.array]),
        automationId: PropTypes.string,
        preferences: PropTypes.object,
    };

    static defaultProps = {
        channels: [],
        automationId: 'image-map-Banner',
        preferences: {},
    };

    constructLeaf = (mapArea) =>
        mapArea.map((data = {}) => {
            const bannerData = {};
            if (data.link && data.link.url) {
                bannerData.leaf = data.link.url.indexOf('X2H2') < 0;
                bannerData.link = data.link.url;
            }
            bannerData.alt = data.linkText; // for alt Tag
            /* istanbul ignore next */
            bannerData.target = data.openInNewTab ? '_blank' : '_self';

            return { ...data, ...bannerData };
        });

    render() {
        const { channels, automationId, preferences } = this.props;
        const bannerData = channels[0];
        let imageurl = get(bannerData, 'image.url', '');
        imageurl = replaceSubdomain(imageurl, preferences);
        const imageDimensions = get(bannerData, 'image.dimensions', '');

        return (
            <ImageMapBanner
                imageUrl={imageurl}
                imagemapArea={this.constructLeaf(get(bannerData, 'hotspots', []))}
                imageAltText={get(bannerData, 'image.altText', '')}
                imageDimensions={get(bannerData, 'image.dimensions', '')}
                imageWidth={imageDimensions ? imageDimensions.width : ''}
                imageHeight={imageDimensions ? imageDimensions.height : ''}
                analyticsTag={get(bannerData, 'analyticsTag', '')}
                automationId={automationId}
            />
        );
    }
}

export default IrisImageMapBanner;
